export default __webpack_public_path__ + "static/media/red-lotus.a63958bc.svg";